export default "__VITE_ASSET__D3woZVem__"